import React from 'react'
import Head from 'next/head'
import Cookies from 'js-cookie'
import { withTranslation } from '~/i18n'

const NoDealerAccess = ({ t }) => {
  const logout = () => {
    for (const name of [
      'session',
      'currentDealer',
      'access_token',
      'access_realm',
    ]) {
      Cookies.remove(name)
    }
    window.location.assign('/login')
  }

  return (
    <main className="py-8 px-4 flex flex-col items-center text-center">
      <Head>
        <title>{t('No accessible dealer')} - Via.Delivery</title>
      </Head>
      <img
        src="/assets/viadelivery-logo.png"
        alt="Via.Delivery"
        width={160}
        height={54}
      />
      <div className="p-8 bg-white mt-8 shadow-lg rounded">
        <h1 className="text-2xl font-bold mb-4">{t('No accessible dealer')}</h1>
        <p role="status" className="mb-6">
          {t('Dealer access help')}
        </p>
        <button
          className="border rounded px-4 py-2 mr-4"
          onClick={() => window.location.reload()}
        >
          {t('Check dealer access again')}
        </button>
        <button className="border rounded px-4 py-2" onClick={logout}>
          {t('Log out')}
        </button>
      </div>
    </main>
  )
}

export default withTranslation('common')(NoDealerAccess)
